
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { defineComponent } from 'vue';
import { IDashboardActions } from '../types';
import { IExportActions, IExportState } from '../types/exportStore';
import DashboardDailyBilling from './DashboardDailyBilling.vue';
import DashboardMonthlyBilling from './DashboardMonthlyBilling.vue';
import DashboardBilledReserved from './DashboardBilledReserved.vue';
import DashboardReservedCollected from './DashboardReservedCollected.vue';
import DashboardLeadTime from './DashboardLeadTime.vue';
import DashboardCard from './DashboardCard.vue';
import { segments } from '@/common/helpers/Segments';
const { useActions } = createNamespacedHelpers<null, null, IDashboardActions>(
  'dashboard'
);
const { useState } = createNamespacedHelpers<
  IExportState,
  null,
  IExportActions
>('dashboard/exportStore');

export default defineComponent({
  name: 'DashboardExport',

  components: {
    DashboardDailyBilling,
    DashboardMonthlyBilling,
    DashboardBilledReserved,
    DashboardReservedCollected,
    DashboardLeadTime,
    DashboardCard,
  },

  methods: {
    checkSegments(segment) {
      return segment === 'Calçados'
        ? this.fetchData({ segment: [segments['1'].cod] })
        : this.fetchData({
            segment: [segments['2'].cod, segments['5'].cod],
          });
    },
  },

  setup() {
    const {
      dailyBillingTotals,
      monthlyBillingTotals,
      monthTotals,
      billedReservedTotals,
      reservedCollectedTotals,
      reservedCollectedTotalsShoes,
      leadTimeTotals,
      loadingDailyBilling,
      loadingMonthlyBilling,
      loadingMonthTotals,
      loadingBilledReserved,
      loadingReservedCollected,
      loadingLeadTime,
      weekdays,
    } = useState([
      'dailyBillingTotals',
      'monthlyBillingTotals',
      'monthTotals',
      'billedReservedTotals',
      'reservedCollectedTotals',
      'reservedCollectedTotalsShoes',
      'leadTimeTotals',
      'loadingDailyBilling',
      'loadingMonthlyBilling',
      'loadingMonthTotals',
      'loadingBilledReserved',
      'loadingReservedCollected',
      'loadingLeadTime',
      'weekdays',
    ]);

    const { fetchData } = useActions(['fetchData']);

    return {
      fetchData,
      dailyBillingTotals,
      monthTotals,
      monthlyBillingTotals,
      billedReservedTotals,
      reservedCollectedTotals,
      reservedCollectedTotalsShoes,
      leadTimeTotals,
      loadingDailyBilling,
      loadingMonthlyBilling,
      loadingMonthTotals,
      loadingBilledReserved,
      loadingReservedCollected,
      loadingLeadTime,
      weekdays,
    };
  },
});
